import ExcludeFromLookup from '../../../../../../enums/ExcludeFromLookup';
import stripCharacters from '../../../../../utils/strip-characters';
import {onlyDeliveryAddresses} from '../../addressFormType';
import addressLine2 from '../../defaultFieldDefinitions/AddressLine2';
import streetName from '../../defaultFieldDefinitions/StreetName';
import townCity from '../../defaultFieldDefinitions/TownCity';
import jpPostcode from '../../validationByCountry/Japan/jp-postcode';
import * as max from '../../max-length-validators';
import * as required from '../../required-validators';
import romanCharactersOnly from '../../roman-characters-only';

const formatJpPostcode = (value) => {
  if (!value) return value;
  
  return value.replace(/-/g, '');
};

const isExperiment = window.start.siteDataV2?.clientExperiments?.show_loqate_input_for_japan_01 === 'v1|show_loqate_input_for_japan_01'
  || window.start.settings?.activate_loqate_v4;

const FieldDefinitionJP = [
  {
    name: 'addressee',
    label: 'checkout.delivery.address.field.label.fullNameRomanCharsOnly.text',
    filterCondition: onlyDeliveryAddresses,
    required: true,
    maxLength: 30,
    validate: [required.fullName, max.lengthAddressee(30), romanCharactersOnly],
    excludeFromAddressLookup: ExcludeFromLookup.BEFORE,
  },
  {
    name: 'postCode',
    label: isExperiment
      ? 'checkout.delivery.address.field.label.postal.code.text.experimental'
      : 'checkout.delivery.address.field.label.postal.code.text',
    required: true,
    maxLength: 7,
    validationCleaner: stripCharacters('-'),
    transform: formatJpPostcode,
    validate: [required.postCode, max.lengthPostCode(7), jpPostcode],
  },
  {
    name: 'county',
    label: isExperiment
      ? 'checkout.address.field.label.county.text.experimental'
      : 'checkout.address.field.label.county.text',
    required: true,
    maxLength: 30,
    validate: [max.lengthAddress(30), required.county],
  },
  {
    ...townCity,
    label: isExperiment
      ? 'checkout.delivery.address.field.label.town.text.experimental'
      : 'checkout.delivery.address.field.label.town.text',
    maxLength: 30,
    validate: [required.townCity, max.lengthAddress(30)],
  },
  {
    ...streetName,
    label: isExperiment
      ? 'checkout.address.field.label.address1.text.experimental'
      : 'checkout.address.field.label.address1.text',
    maxLength: 30,
    validate: [required.address1, max.lengthAddress(30)],
  },
  {
    ...addressLine2,
    label: isExperiment
      ? 'checkout.address.field.label.address2.text.experimental'
      : 'checkout.address.field.label.address2.text',
    maxLength: 30,
    validate: [max.lengthAddress(30)],
    infoMessage: 'checkout.address.field.label.address2.message',
  },
];

export default FieldDefinitionJP;
